var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1339_7556)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1339_7556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7V5H22V7H14ZM14 11V9H22V11H14ZM14 15V13H22V15H14ZM8 14C7.16667 14 6.45833 13.7083 5.875 13.125C5.29167 12.5417 5 11.8333 5 11C5 10.1667 5.29167 9.45833 5.875 8.875C6.45833 8.29167 7.16667 8 8 8C8.83333 8 9.54167 8.29167 10.125 8.875C10.7083 9.45833 11 10.1667 11 11C11 11.8333 10.7083 12.5417 10.125 13.125C9.54167 13.7083 8.83333 14 8 14ZM2 20V18.1C2 17.75 2.08333 17.4167 2.25 17.1C2.41667 16.7833 2.65 16.5333 2.95 16.35C3.7 15.9 4.49583 15.5625 5.3375 15.3375C6.17917 15.1125 7.06667 15 8 15C8.93333 15 9.82083 15.1125 10.6625 15.3375C11.5042 15.5625 12.3 15.9 13.05 16.35C13.35 16.5333 13.5833 16.7833 13.75 17.1C13.9167 17.4167 14 17.75 14 18.1V20H2Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1339_7556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1339_7556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/UserManagement.d1d2856e2c3ef0d82f1a5a74033c792f.svg";
export { ForwardRef as ReactComponent };